import { useState } from 'react';
import axios from 'axios';
import './solicitudes.css';
import { EstadoSolicitud } from './EstadoSolicitud';
export default function SolicitudTabla({ solicitud, setIsOpen, setSelectedSolicitud, theme, estados }) {
  const [loading, setLoading] = useState(false);
  const handleClick = async () => {
    if (!solicitud?.nroStro) return;
    try {
      setLoading(true);
      // Llamada a tu API para buscar el ID según el nroStro
      const response = await axios.get(`https://reclamosback.agsseguros.online/apiReclamos/empleadosSolicitudes/obtener-id/${solicitud.nroStro}`);
      const data = await response.data;
      if (data?.id) {
        window.open(`/#/${data.id}`, '_blank');
      } else {
        console.error('No se encontró el ID.');
      }
    } catch (error) {
      console.error('Error buscando el ID:', error);
    } finally {
      setLoading(false);
    }
  };
  const formatDDMMYYYY = fechaISO => {
    const [anio, mes, dia] = fechaISO.split('-');
    return `${dia}/${mes}/${anio}`;
  };
  return (
    <tr className='bodyTablaDark'>
      <th onClick={handleClick} disabled={loading} className='textoBodyTablaLight' style={{ cursor: 'pointer', width: '100px' }}>
        {solicitud?.nroStro}
      </th>
      <th className='textoBodyTablaLight' style={{ width: '140px' }}>
        {solicitud?.fechaSolicitud}
      </th>
      <th className='textoBodyTablaLight' style={{ width: '120px' }}>
        {solicitud?.patenteAseg}
      </th>
      <th className='textoBodyTablaLight' style={{ width: '120px' }}>
        {formatDDMMYYYY(solicitud.fechaStroRec)}
      </th>
      <th className='textoBodyTablaLight' style={{ width: '120px' }}>
        {solicitud?.patenteRec}
      </th>
      <th className='textoBodyTablaLight' style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '200px' }} title={solicitud?.obsReclamante || ''}>
        {solicitud?.obsReclamante}
      </th>
      <th>
        <EstadoSolicitud estado={solicitud.estado} estadoCompleto={solicitud.estadoReclamoValor} estados={estados} />
      </th>
      <th className='textoBodyTablaLight' style={{ width: '100px' }}>
        {solicitud?.docOffice ? 'SI' : 'NO'}
      </th>
      <th className='textoBodyTablaLight'>{solicitud?.ultMod}</th>
      <th className='col-icon'>
        <button className='ingresarContainerBodyLight' style={{ border: 'none' }} onClick={handleClick}>
          <i className='bi bi-arrow-right' style={{ color: '#FFFFFF' }}></i>
        </button>
      </th>
    </tr>
  );
}
